/**
 * Namespaces the keyword a search session is anchored on so a keyword slug can never collide with a category id
 * (e.g. user types "1" while a separate flow browses category id 1) and to make the field self-documenting.
 */
export const getKeywordSessionKey = (searchTerm?: string) => (searchTerm ? `keyword:${searchTerm}` : undefined);
